<script setup>
const props = defineProps(['person'])
const person = props.person;

const houseSuffix = person.address.suffix ? '-'+person.address.suffix : '';
const listItems = [
    person.firstName,
    person.job,
    person.organisation,
    person.reference ? 'Referentie: '+person.reference : null,
    person.email,
    person.phone,
    person.address.zipcode,
    person.address.city,
    person.address.streetname+' '+person.address.housenumber+houseSuffix,
];
</script>

<template>
  <div class="formcard">
    <div class="formcard__header">
      <p class="coursecard__title">{{ person.initials }} {{ person.prefix }} {{ person.lastName }}</p>
      <p class="formcard__big" v-if="person.big">BIG/KRM: {{ person.big }}</p>
    </div>
    <div class="formcard__info">
      <ul class="formcard__list">
        <template v-for="(value, key) in listItems">
          <li v-if="value">
            {{ value }}
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>